import { CountBadge } from '@statura/ui';

/** Occupies the bottom of a 44px rail control, below its 16px icon. */
export function RailCountBadge({ count }: { count?: number }) {
  if (typeof count !== 'number' || count <= 0) return null;
  return (
    <CountBadge
      compact
      count={count}
      label="items need attention"
      className="absolute bottom-0.5 left-1/2 -translate-x-1/2 bg-status-warning-bg text-status-warning-fg"
    />
  );
}
